export default __webpack_public_path__ + "static/media/icon_attractions.d4950bb2.svg";